import axios from 'axios';
import { groupBy, mergeArrsByKey } from '@/helpers';

import { httpWithLoader } from '@/http-common';

const state = () => ({
    hints: [] // Подсказки
});

const getters = {};

const mutations = {
    SET_HINTS(state, hints) {
        state.hints = hints
    }
};

const handleError = ((error, commit) => {
    commit('common/TOGGLE_ALERT', { open: true, status: 'error', text: `Что то пошло не так, пожалуйста перезагрузите страницу и попробуйте ещё раз` }, { root: true })
    console.log(`url: ${ error.config ? error.config.url : '-' }\nmethod: ${ error.config ? error.config.method : '-' }\npayload: ${ error.config ? error.config.data : '-' }`);

    if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        const tempMessage = error.response.data.trace.map(el => el.file).join('\n')
        console.log(`message: ${error.response.data.message}\nfiles:\n${tempMessage}`);
    } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the 
        // browser and an instance of
        // httpWithLoader.ClientRequest in node.js
        console.log(error.request);
    } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Ошибка', error.message);
    }
});

const actions = {
    async LOAD_HINTS({ commit, rootState }, hint_code) {
        await httpWithLoader.get(`/hint/${ hint_code }`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_HINTS', response.data)
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },
    async UPDATE_HINTS({ commit, rootState }, { hint_code, data }) {
        await httpWithLoader.put(`/hint/${ hint_code }`, data, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then()
        .catch((reject) => {
            handleError(reject, commit)
        });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
